export default __webpack_public_path__ + "static/media/icon-zoom.e9869e17.svg";